var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"free-text my-3 rounded p-2"},[_c('p',{ref:"contentValue",staticClass:"text-custom w-100 font-weight-bold border-0 shadow-none m-0",style:([_vm.questionColorStyle, _vm.componentAlignment]),domProps:{"innerHTML":_vm._s(_vm.componentContent.value)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }